import { Flex } from "@chakra-ui/react";

import ToggleSwitch from "./ToggleSwitch";
import SettingsContentsTitle from "../../../organism/Settings/SettingsContent/Common/SettingsContentsTitle";

import { BlockVisibility, BlockVisibilityType } from "../../../../types/block/enum";
import {
  StartOfWeekOption,
  TimeFormatOption,
  DefaultDurationOption,
} from "../../../../types/account/enum";
import { PreferencesType } from "../../../../types/account/type";
import {
  START_OF_WEEK,
  TIME_FORMAT,
  DEFAULT_DURATION,
  DEFAULT_VISIBILITY,
} from "../../../../constants/settings/preference";
import { usePreference } from "../../../../hooks/preference/usePreference";
import { DefaultPreferenceOptions } from "../../../../constants/userPreference";

const Preferences: React.FC = () => {
  const { preference: userPreference, updatePreference: updateUserPreference } = usePreference();

  const createPreferenceHandler = <T extends keyof PreferencesType>(key: T) => {
    return (newValue: PreferencesType[T]) => {
      updateUserPreference({ [key]: newValue });
    };
  };

  const handleStartOfWeekChange = createPreferenceHandler(START_OF_WEEK);
  const handleTimeFormatChange = createPreferenceHandler(TIME_FORMAT);
  const handleDefaultDurationChange = createPreferenceHandler(DEFAULT_DURATION);
  const handleVisibilityChange = createPreferenceHandler(DEFAULT_VISIBILITY);

  if (!userPreference) return null;
  return (
    <Flex
      direction="column"
      justify="stretch"
      w="100%"
      h="100%"
      flexGrow={1}
      maxW="650px"
      px="30px"
      gap="30px"
    >
      <SettingsContentsTitle title="Preferences" />
      <Flex
        direction="column"
        h="max-content"
        borderTop="1px solid rgba(255, 255, 255, 0.08)"
        alignSelf="stretch"
      >
        <ToggleSwitch<StartOfWeekOption>
          title="Start of week"
          options={[StartOfWeekOption.SUNDAY, StartOfWeekOption.MONDAY]}
          selectedOption={userPreference?.startOfWeek ?? DefaultPreferenceOptions.startOfWeek}
          onOptionChange={handleStartOfWeekChange}
        />
        <ToggleSwitch<TimeFormatOption>
          title="Time format"
          options={[TimeFormatOption.HOUR12, TimeFormatOption.HOUR24]}
          selectedOption={userPreference?.timeFormat ?? DefaultPreferenceOptions.timeFormat}
          onOptionChange={handleTimeFormatChange}
        />
        <ToggleSwitch<DefaultDurationOption>
          title="Default duration"
          options={[
            DefaultDurationOption.MIN15,
            DefaultDurationOption.MIN30,
            DefaultDurationOption.MIN60,
          ]}
          selectedOption={
            userPreference?.defaultDuration ?? DefaultPreferenceOptions.defaultDuration
          }
          onOptionChange={handleDefaultDurationChange}
        />
        <ToggleSwitch<BlockVisibilityType>
          title="Visibility"
          options={[BlockVisibility.PUBLIC, BlockVisibility.DEEPWORK, BlockVisibility.INVISIBLE]}
          selectedOption={
            userPreference?.defaultVisibility ?? DefaultPreferenceOptions.defaultVisibility
          }
          onOptionChange={handleVisibilityChange}
        />
      </Flex>
    </Flex>
  );
};

export default Preferences;
